export class RestoreImageInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "image",
            "baseName": "image",
            "type": "RestoreImageImageInput",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "Array<RestoreImageVolumeInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreImageInput.attributeTypeMap;
    }
    constructor() {
    }
}
